import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import AudioRecorder from "../../../../components/AudioRecorder";
import {useParams} from "react-router-dom";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import useForm from "../../../../hooks/useForm";
import {tokenizeSentence} from "../../../../utils/utils";
import URLS from "../../../../API/Axios/URLS";
import SpeakAboutThePhotoModal from "../Modal/SpeakAboutThePhotoModal";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import AnswerDropDown from "../component/AnswerDropDown";
import {BASE_URL} from "../../../../settings/settings";


function MapQuestion(question) {

    return (
        <div className={"w-auto text-bawa justify-center items-center  self-center text-wrap"}>
            <p className={" font-bold mb-5"}>{question?.text}</p>
            <ul className={"list-disc"}>
                {
                    question?.suggestion?.map((item, index) => {
                        return (
                            <li key={index} className={" items-center mb-2"}>{item}</li>
                        )
                    })
                }
            </ul>


        </div>
    )
}

export default function ReadThenSpeak({className, ...props}) {
    const {id} = useParams()
    const {question, questionActions} = useQuestion()
    useEffect(() => {
        questionActions.loadQuestions(id)
    }, [])

    // my code
    const [showModal, setShowModal] = useState(false)
    const [response, setResponse] = useState({})
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: "",
        time: 0,
        inputType: "audio"
    })




    async function submitAnswer() {
        if (form?.time < 10) {
            actions.setError({
                non_field_errors: ["Recording should be at least 30 seconds"]
            })
            return
        }
        let answerText = await questionActions.convertBlobToText(form?.answer)

        let text = answerText.data
        if (tokenizeSentence(text).length < 30) {
            actions.setError({
                non_field_errors: [`Answer should be at least 20 words`]
            })
            return
        }
        let answerUrl =BASE_URL.replace(/\/$/, "")+ answerText?.audioUrl

        actions.post(URLS.genericQuestionView, (data) => {
            return {
                ...data,
                answer: text,
                answerUrl: answerUrl
            }
        }).then(response => {
            setResponse(response?.data)
            setShowModal(true)
        })


    }

    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit + 20000}

            />
            <SpeakAboutThePhotoModal showModal={showModal} setShowModal={setShowModal} result={response}/>
            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>
                <div className={"flex flex-1 px-8 flex-col items-center justify-center gap-4"}>
                    <MapQuestion {...question}/>

                    <AudioRecorder
                        setAnswer={(data) => {
                            setFormData({
                                answer: data,
                                time: Math.round(data.duration)
                            })
                        }}
                        answer={form?.answer}
                    />


                    {
                        form?.answer &&
                        <audio
                            onLoadedMetadata={(e) => {
                                console.log(e)
                            }}
                            className={"bg-white self-center rounded-full"} controls src={form?.answer.audioUrl}/>


                    }
                    <FormNoneFieldErrors errors={error?.answer || error?.non_field_errors || error?.time}/>


                </div>
            </div>
            <QuestionFooter
                className={"mx-4 my-2"}
                loading={loading}
                onClickSubmit={submitAnswer}/>

            <div className={"flex flex-1 flex-col overflow-hidden"}>


                <AnswerDropDown
                    className={" mt-4 "}
                    headerTitle={"Show Answer"}
                    allowEditing={true}

                    justifications={question?.answerText}
                />


            </div>


        </div>

    )
}
